// You can write more code here

import { CheckboxController } from '@/game/GameComponents/PhaserGame/UI/CheckboxController';

/* START OF COMPILED CODE */

export default class CheckboxSmall extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// checkboxBacking
		const checkboxBacking = scene.add.image(0, 0, "8check05");
		checkboxBacking.scaleX = 3;
		checkboxBacking.scaleY = 3;
		this.add(checkboxBacking);

		this.checkboxBacking = checkboxBacking;

		/* START-USER-CTR-CODE */
    this.brain = new CheckboxController(this);
    /* END-USER-CTR-CODE */
	}

	public checkboxBacking: Phaser.GameObjects.Image;
	public IsInteractive: boolean = true;

	/* START-USER-CODE */

  public brain: CheckboxController;
  public onTexture: string = '8check02';
  public offTexture: string = '8check05';
  public disabledOffTexture: string = '8check05';
  public disabledOnTexture: string = '8check02';
  public hoverOnTexture: string = '8check02';
  public hoverOffTexture: string = '8check05';

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
